import { cn } from '@/lib/utils'

interface SkeletonProps extends React.ComponentProps<'div'> {
  loading?: boolean
  children?: React.ReactNode
}

function Skeleton({
  className,
  loading = true,
  children,
  ...props
}: SkeletonProps) {
  if (!loading) {
    return <>{children}</>
  }

  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...props}
    />
  )
}

export { Skeleton }
